import { createContext, useContext } from "react";
import { createBrowserHistory } from "history";
import { syncHistoryWithStore, RouterStore } from "mobx-react-router";

import { AuthStore } from "./AuthStore";
import { GeneralStore } from "./GeneralStore";
import { UserStore } from "./UserStore";
import { AccessLevelStore } from "./AccessLevelStore";
import { DepositStore } from "./DepositStore";
import { GameStore } from "./GameStore";
import { PartnerStore } from "./PartnerStore";
import { AuditStore } from "./AuditStore";
import { BoardStore } from "./BoardStore";
import { MachineStore } from "./MachineStore";
import { ScanStore } from "./ScanStore";
import { DashboardStore } from "./DashboardStore";
import { ReasonStore } from "./ReasonStore";

export class RootStore {
  public routerStore = new RouterStore();
  public authStore = new AuthStore(this);
  public generalStore = new GeneralStore(this);
  public userStore = new UserStore(this);
  public accessLevelStore = new AccessLevelStore(this);
  public depositStore = new DepositStore(this);
  public gameStore = new GameStore(this);
  public partnerStore = new PartnerStore(this);
  public auditStore = new AuditStore(this);
  public boardStore = new BoardStore(this);
  public machineStore = new MachineStore(this);
  public scanStore = new ScanStore(this);
  public dashboardStore = new DashboardStore(this);
  public reasonStore = new ReasonStore(this);

  public history = syncHistoryWithStore(
    createBrowserHistory(),
    this.routerStore
  );
}

const rootStore = new RootStore();
export const { history, ...providers } = rootStore;

const storeCtx = createContext(providers);
export function useStores() {
  return useContext(storeCtx);
}
